import React, { useEffect } from "react";
import EventsGrid from "./landingPage/EventsGrid";
import NewsletterSection from "./landingPage/SupportSection";
import HeroSection from "./landingPage/HeroSection";
import EventsChatWidget from "./EventsChatWidget";
import { useClarity } from "../../hooks/useClarity";

const LandingPage = () => {
  const clarity = useClarity();

  useEffect(() => {
    // Track landing page views (lightweight, only once)
    clarity.event("landing_page_viewed");

    // Additional overscroll prevention for mobile devices
    const preventOverscroll = (e) => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;

      // Prevent scrolling past the top
      if (scrollTop === 0 && e.deltaY < 0) {
        e.preventDefault();
      }

      // Prevent scrolling past the bottom
      if (scrollTop + clientHeight >= scrollHeight && e.deltaY > 0) {
        e.preventDefault();
      }
    };

    // Add event listeners for wheel events (desktop)
    document.addEventListener("wheel", preventOverscroll, { passive: false });

    // Cleanup function
    return () => {
      document.removeEventListener("wheel", preventOverscroll);
    };
  }, [clarity]); // Include clarity in dependencies

  return (
    <div style={{ overscrollBehavior: "none" }}>
      <HeroSection />
      <EventsGrid />
      <NewsletterSection />
      <EventsChatWidget />
    </div>
  );
};

export default LandingPage;
